/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store/store.js'
import event from './event'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    /**
     * @param worker {ServiceWorkerRegistration}
     */
    ready (worker) {
      store.commit('log', 'App is being served from cache by a service worker.')
      store.commit('setWorker', worker)
    },
    /**
     * @param worker {ServiceWorkerRegistration}
     */
    registered (worker) {
      store.commit('log', 'Service worker has been registered.')
      store.commit('setWorker', worker)
    },
    /**
     * @param worker {ServiceWorkerRegistration}
     */
    cached (worker) {
      store.commit('log', 'Content has been cached for offline use.')
      store.commit('setWorker', worker)
    },
    /**
     * @param worker {ServiceWorkerRegistration}
     */
    updatefound (worker) {
      store.commit('log', 'New content is downloading.')
      event.$emit('sw:update-found')
      store.commit('setWorker', worker)
    },
    /**
     * @param worker {ServiceWorkerRegistration}
     */
    updated (worker) {
      store.commit('hasUpdated', true)
      store.commit('log', 'New content is available; please refresh!')
      event.$emit('sw:updated')
      store.commit('setWorker', worker)
    },
    offline () {
      store.commit('log', 'No internet connection found. App is running in offline mode.')
    },
    error (error) {
      store.commit('log', `Error during service worker registration: ${error}`)
    }
  })
}
